// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Pm-z","tupacHeader":"Qm-z","tupacHeader2":"Rm-z","tupacMenu":"Sm-z","tupacMenu2":"Tm-z","tupacMain":"Um-z","tupacMain2":"Vm-z"};